import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';
import { api } from '@/lib/api-client';
import { MutationConfig } from '@/lib/tanstack-query';

export const DeliverOrderInputSchema = z.object({});

export type DeliverOrderInput = z.infer<typeof DeliverOrderInputSchema>;

export const deliverOrder = async ({ orderId }: { orderId: string }): Promise<void> => {
  return (await api.post(`/orders/${orderId}/deliver`)).data;
};

type DeliverOrderOptions = {
  mutationConfig?: MutationConfig<typeof deliverOrderInvitation>;
};

export const useDeliverOrder = ({ mutationConfig }: DeliverOrderOptions = {}) => {
  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    onSuccess: (...args) => {
      // queryClient.refetchQueries({});
      onSuccess?.(...args);
    },
    ...restConfig,
    mutationFn: deliverOrder,
  });
};
